export default __webpack_public_path__ + "static/media/Pistol_2.87994faf.png";